// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Flyout .RibbonOverflowFlyout .RibbonItem{width:100%}.Flyout .RibbonOverflowFlyout .RibbonItem .Button{justify-content:left}.Flyout .RibbonOverflowFlyout .RibbonItem .Button:hover{background-color:transparent}", ""]);
// Exports
module.exports = exports;
